import React, { useEffect } from "react";
import { Progress, Table  } from 'antd';
import { connect } from "react-redux";
import { handleTableChange } from "../../../../utils/index";
import HeaderComponent from "components/card/HeaderComponent";
import { 
	getTrainingClassList, 
} from "../../../../redux/trainingclass/trainingClassState";



const TrainingCoursesTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters,
}) => {

  	const columns = [
		{
	        title: `Course`,
			width: '30%',
	        dataIndex: 'tcl_title',
	        key: 'tcl_title',
	        render:(_, record) => <>
						<div className="font-medium">{record?.tcl_title}</div>
						<div className="text-[12px] text-slate-700 dark:text-slate-200">{record?.tcl_code}</div>
					</>
	    },
		{
			title: `Category`,
			width: '20%',
			dataIndex: 'course_cat_name',
			key: 'course_cat_name',  
			render: (_, record) => <span className="inline-flex items-center justify-center rounded-xl border px-2 py-0.5 text-xs font-medium text-slate-900 dark:text-slate-100">
						{record?.course_cat_name}
					</span> 
		},
		{
	        title: `Duration`,
			width: '15%',
	        dataIndex: 'tcl_duration',
	        key: 'tcl_duration',
	        render:(tcl_duration) => <span>{tcl_duration}</span> 
	    },
		{
	        title: `Enrolled`,
			width: '10%',
			dataIndex: 'enrolled_count',
	        key: 'enrolled_count',
	        render:(enrolled_count) => <span>{enrolled_count}</span> 
	    },
		{
	        title: `Completed`,
			width: '10%',
			dataIndex: 'tcl_completed_count',
	        key: 'tcl_completed_count',
	        render:(tcl_completed_count) => <span className="text-green-600">{tcl_completed_count}</span>
	    },
		{
			title: `Completion Rate`,
			dataIndex: 'completion_rate',
			width: '15%',
			key: 'completion_rate',
			render: (value) => (
				<Progress
					percent={value}                        
					showInfo
					size="small"
					strokeColor="#10B981"                  
					trailColor="rgba(16, 185, 129, 0.2)"  
					format={(percent) => `${percent}%`}    
				/>
			)
		}

		

    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
			
			<HeaderComponent
              title="Available Training Courses"
              description="Overview of all training programs and their enrollment statistics"
	          >
				<Table
					size="small"
					dataSource={recordList} 
					columns={columns} 
					rowKey={(record) => record.tcl_id}
					pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
				/>
            </HeaderComponent>
		</div>
  	);
};

const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassList?.items,
	pagination: state.trainingClass.trainingClassList?.pagination,
	filters: state.trainingClass.trainingClassList?.filters,
	requesting: state.trainingClass.trainingClassList?.requesting,
	error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCoursesTable);
